import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Block from './BlockContent';

import './block-layout.scss';

class BlockLayout extends PureComponent {
  render() {
    const { layout, items } = this.props;

    if (layout === 1) {
      return (
        <div className="block-layout">
          <div className="block-row">
            <div className="block-col">
              <Block {...items[0]}/>

              <Block {...items[1]}/>
            </div>

            <div className="block-col">
              <Block {...items[2]}/>
            </div>
          </div>
        </div>
      );
    }

    if (layout === 2) {
      return (
        <div className="block-layout">
          <Block {...items[0]}/>

          <div className="block-row">
            <div className="block-col">
              <Block {...items[1]}/>
            </div>

            <div className="block-col">
              <Block {...items[2]}/>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }
}

BlockLayout.propTypes = {
  layout: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default BlockLayout;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/BlockLayout.js